document.addEventListener("turbo:load", function () {
  let scrollBtn = document.getElementById("back-to-top-btn");
  if (!scrollBtn) return;

  window.addEventListener("scroll", function () {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      scrollBtn.classList.add("visible");
    } else {
      scrollBtn.classList.remove("visible");
    }
  });

  scrollBtn.addEventListener("click", function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  document.querySelectorAll("[data-floating-tooltip]").forEach(function (el) {
    new bootstrap.Tooltip(el, {
      title: el.getAttribute("data-floating-tooltip"),
      placement: "left",
      trigger: "hover",
    });
  });
});
